const namespace = 'bravissimo/hreflang';

export const UPDATE_HREFLANG = `${namespace}/UPDATE_HREFLANG`;
